<script>
import Button from '@/components/Button'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import FieldsValidator from '@/components/FieldsValidator'
import StringUtils from '@/utils/stringUtils'
import AccountsServices from '@/services/accounts'

const STEPS = { EDIT_INFO: 0, VALIDATE_PASSWORD: 1, SUCCESS: 2 }

export default
{
    name: 'account',

    render () 
    {
        return (
            <div id='account-view'>
                <fields-validator ref='fieldsValidator'>
                    <div class='edit-step' v-show={this.currentStep == STEPS.EDIT_INFO}>
                        <div class='section-title'>Mot de passe</div>
                        <floating-label-text-input type='password' placeholder='Nouveau mot de passe' v-model={this.newPassword} optional={true}
                            validation='not-empty' />
                        <div class='section-title'>Courriel</div>
                        <floating-label-text-input placeholder='Mon courriel' v-model={this.email} validation='email' />
                    </div>

                    <div class='validate-step' v-show={this.currentStep == STEPS.VALIDATE_PASSWORD}>
                        <div class='section-title'>Valider mes changements</div>
                        <floating-label-text-input class='current-password-field' type='password' placeholder='Mot de passe actuel' v-model={this.currentPassword}
                            v-show={this.hasChanged} validation='not-empty' ref='currentPasswordField'
                            validation-hint='Pour valider vos modifications vous devez fournir votre mot de passe actuel' />
                    </div>

                    <div class='success-step' v-show={this.currentStep == STEPS.SUCCESS}>
                        <div class='section-title'>Vos changements ont été enregistrés</div>
                        <inline-svg class='success-visual' src={require('@/assets/img/checked.svg')} />
                        <Button class='go-back-button' on-click={() => this.$router.push('/settings')} text='Retourner aux paramètres' />
                    </div>

                    <Button class='next-step-button' text='Enregistrer les modifications' disabled={!this.hasChanged} v-show={this.currentStep != STEPS.SUCCESS}
                        on-click={this.onNextStepButtonClicked} />
                </fields-validator>
            </div>
        )
    },

    data () 
    {
        return {
            currentStep: STEPS.EDIT_INFO,
            viewTitle: 'Mon Compte',
            email: this.$store.state.user.email,
            newPassword: '',
            currentPassword: ''
        }
    },

    mounted ()
    {
    },

    computed:
    {
        hasEmailChanged ()
        {
            return this.$store.state.user.email != this.email
        },

        hasNewPassword ()
        {
            return !StringUtils.isEmptyString(this.newPassword)
        },

        hasChanged ()
        {
            return this.hasEmailChanged || this.hasNewPassword
        }
    },

    methods:
    {
        onNextStepButtonClicked (e, button)
        {
            button.showSpinnerWhile(async () =>
            {
                if (this.currentStep == STEPS.EDIT_INFO) await this.proceedEditInfoStep()
                else if (this.currentStep == STEPS.VALIDATE_PASSWORD) await this.proceedValidatePasswordStep()
            })
        },

        async proceedEditInfoStep ()
        {
            if (!this.$refs.fieldsValidator.validate()) return

            this.currentStep += 1
        },

        async proceedValidatePasswordStep ()
        {
            if (!this.$refs.fieldsValidator.validate()) return

            const email = this.hasEmailChanged ? this.email : null
            const password = this.hasNewPassword ? this.newPassword : null

            try
            {
                const res = await AccountsServices.updateAccount(this.$store.state.user.token, {email, password}, this.currentPassword)
                await this.$store.commit('user/setContext', res)
                this.currentStep += 1
            }
            catch (e)
            {
                this.$refs.currentPasswordField.setErrorMessage('Ce mot de passe est erroné')
            }
        }
    },

    components:
    {
        FieldsValidator,
        Button,
        FloatingLabelTextInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#account-view
{
    padding: 20px 0;

    .section-title
    {
        font-weight: 700;
        font-size: 23px;
        margin-bottom: 10px;

        &:not(:first-of-type)
        {
            margin-top: 20px;
        }
    }

    .floating-label-text-input
    {
        &:not(:first-of-type)
        {
            margin-top: 10px;
        }

        &.current-password-field
        {
            margin-top: 20px;
        }
    }

    .next-step-button
    {
        width: -webkit-fill-available;
        margin-top: 15px;
    }

    .success-visual
    {
        margin: 30px 85px;
        fill: var(--theme-accent-color);
    }

    .go-back-button
    {
        width: -webkit-fill-available;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Account.vue